define(['moment-wrapper', 'modules/common/controls/input'], (moment, Input) => Input.extend({

    binders: _.extend({}, Input.prototype.binders, {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.get());
                };
                view.$el.on('change', this.callback);
            },
            unbind (view) {
                view.$el.off('change', this.callback);
            },
            routine (view, value) {
                view.set(value);
            }
        }
    }),

    render () {
        Input.prototype.render.apply(this, arguments);

        this.$el.datepicker('destroy').datepicker(this.options);
        return this;
    },

    get () {
        const date = this.$el.datepicker('getDate');
        return date ? moment(date).formatDateApi() : null;
    },

    set (date) {
        this.$el.datepicker('setDate', date ? moment(date).toDate() : null);
    },

    remove () {
        this.$el.datepicker('hide').datepicker('destroy');

        return Input.prototype.remove.apply(this, arguments);
    }

}));
